export default function Privacy() {

  return (

    <div className="container-narrow">

      <div className="card">

        <h1>Privacy Policy</h1>

        <p>

          Hopeful Horizons NY respects your privacy and is committed to protecting personal information.

        </p>

        <p>

          Information collected may include contact information, provider qualifications, and service preferences in order to support the directory functionality.

        </p>

        <p>

          We do not sell personal information to third parties.

        </p>

        <p>

          Information may be stored securely using trusted third-party platforms to operate the website.

        </p>

        <p>

          Users are responsible for the information they choose to share publicly within provider profiles.

        </p>

      </div>

    </div>

  );

}